import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsMappingRoute extends Route {
  @service declare access: Services['access'];
  @service declare centralMapping: Services['central-mapping'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }

    if (transition.to?.name === 'hotel.settings.mapping.index') {
      if (this.centralMapping.hasCentralMappingHotelAccess) {
        this.router.transitionTo('hotel.settings.central-mapping.menu');
        return;
      }

      if (this.access.hasBenchmarkInsightMappingTab) {
        this.router.transitionTo('hotel.settings.mapping.benchmark');
        return;
      }
      this.router.transitionTo('hotel.settings.index');
    }

    if (transition?.to?.name === 'hotel.settings.mapping.revenue') {
      if (this.centralMapping.hasCentralMappingHotelAccess) {
        this.router.transitionTo('hotel.settings.central-mapping.menu');
        return;
      }

      this.router.transitionTo('hotel.settings.index');
    }

    this.transition.validatePmsMappingQueryParams(transition);
  }
}
